import { useContext } from "react";
import { Context } from "../components/AuthContextProvider";
// We only want to use the hook directly and never the context component.
export const useAuthContext = () => useContext(Context);
//# sourceMappingURL=useAuthContext.js.map